import { AppLocalLabelsConfig } from './../../../configs/app-local-labels.config';
import { Injectable } from '@angular/core';
import { Router } from '@angular/router'
// import { ActionStepComponent } from 'app/ViewModules/shared-components/action-step/action-step.component';
// import { StatusStepComponent } from 'app/ViewModules/shared-components/status-step/status-step.component';
import { Subject, BehaviorSubject, AsyncSubject, Observable } from 'rxjs';
import { GuidGenerator } from '../../utilities';

@Injectable()
export class InteractService {

  // Start: Workflow Configurator essentials
  workflowSteps = [
    {
      paletteName: 'State',
      step: {
        template: null,
        type: 'state',
        data: {
          name: 'State',
          guid: new GuidGenerator().setGuid()
        }
      }
    },
    {
      paletteName: 'Action',
      step: {
        template: null,
        type: 'action',
        data: {
          name: 'Action',
          guid: new GuidGenerator().setGuid(),
          workflowEventMapping: []
        }
      }
    },
    {
      paletteName: 'Data Entry',
      step: {
        template: null,
        type: 'dataEntry',
        data: {
          name: 'Data Entry',
          guid: new GuidGenerator().setGuid(),
          workflowEventMapping: []
        }
      }
    }
  ]

  mandatorySteps = [
    {
      paletteName: 'Adjudication',
      step: {
        template: null,
        type: 'state',
        data: {
          name: 'State',
          guid: new GuidGenerator().setGuid()
        }
      }
    },
    {
      paletteName: 'Data Entry',
      step: {
        template: null,
        type: 'action',
        data: {
          name: 'Action',
          guid: new GuidGenerator().setGuid()
        }
      }
    },
    {
      paletteName: 'Data Entry',
      step: {
        template: null,
        type: 'dataEntry',
        data: {
          name: 'Data Entry',
          guid: new GuidGenerator().setGuid()
        }
      }
    }
  ]

  workflowList = [
    {
      "workflowDO": {
        "companyName": "Manulife Insurance Ltd",
        "workflowName": "Health Insurance",
        "applicationID": "Claims",
        "updatedBy": "contact@manulife.com",
        "statusCd": "Draft",
        'flowChartJSON': {
          "root": {
            "id": "s1672413087081",
            "type": "state",
            "data": {
              "name": "Claim Registration",
              "guid": "eec84e36-640f-4452-be44-80cb2f1b05d7"
            },
            "children": [
              {
                "id": "s1672413100309",
                "type": "action",
                "data": {
                  "name": "Action",
                  "guid": "72a373df-a076-4e05-9190-2a1e1ca03803",
                  "workflowEventMapping": [
                    {
                      "eventType": "Adjudication",
                      "eventName": "Gender Validation Rule"
                    }
                  ]
                },
                "children": [
                  {
                    "id": "s1672413122089",
                    "type": "manualAdjudication",
                    "data": {
                      "name": "Manual Adjudication",
                      "guid": "5537f0ad-e851-4f53-8a66-1395a2b57510",
                      "workflowEventMapping": []
                    },
                    "children": [
                      {
                        "id": "s1672413134758",
                        "type": "investigation",
                        "data": {
                          "name": "Investigation",
                          "guid": "9d390f4b-dedc-4484-9db1-50f7e8261b1e",
                          "workflowEventMapping": []
                        },
                        "children": [
                          {
                            "id": "s1672413138034",
                            "type": "payout",
                            "data": {
                              "name": "Payout",
                              "guid": "2619ffdb-877c-483a-aa00-899b4dc56325",
                              "workflowEventMapping": []
                            },
                            "children": []
                          }
                        ]
                      }
                    ]
                  },
                  {
                    "id": "s1672413126061",
                    "type": "autoAdjudication",
                    "data": {
                      "name": "Auto Adjudication",
                      "guid": "d684aa4c-fd14-4549-9cc2-aa7c319240d7",
                      "workflowEventMapping": []
                    },
                    "children": [
                      {
                        "id": "s1672413140461",
                        "type": "payout",
                        "data": {
                          "name": "Payout",
                          "guid": "2619ffdb-877c-483a-aa00-899b4dc56325",
                          "workflowEventMapping": []
                        },
                        "children": []
                      }
                    ]
                  }
                ]
              }
            ]
          }
        }
      }
    },
    {
      "workflowDO": {
        "companyName": "Manulife Insurance Ltd",
        "workflowName": "New Business Underwriting",
        "applicationID": "NBU",
        "updatedBy": "contact@manulife.com",
        "statusCd": "Draft",
        "flowChartJSON":{
          "root": {
              "id": "s1672413656570",
              "type": "dataEntry",
              "data": {
                  "name": "Data Entry",
                  "guid": "80e02283-27fd-4caf-ba9e-0b986922aa7d",
                  "workflowEventMapping": []
              },
              "children": [
                  {
                      "id": "s1672413664778",
                      "type": "action",
                      "data": {
                          "name": "Action",
                          "guid": "eabe4146-d442-46a2-9a8a-abf92d508296",
                          "workflowEventMapping": []
                      },
                      "children": [
                          {
                              "id": "s1672413667625",
                              "type": "manualUnderwriting",
                              "data": {
                                  "name": "Manual Underwriting",
                                  "guid": "6a6e804e-8de9-4d17-9113-2cff89021023",
                                  "workflowEventMapping": []
                              },
                              "children": [
                                  {
                                      "id": "s1672413676689",
                                      "type": "policyIssuence",
                                      "data": {
                                          "name": "Policy Issuence",
                                          "guid": "2018e5d9-6954-4811-835a-9d25da6f6678",
                                          "workflowEventMapping": []
                                      },
                                      "children": []
                                  },
                                  {
                                      "id": "s1672413680044",
                                      "type": "policyReject",
                                      "data": {
                                          "name": "Policy Reject",
                                          "guid": "6a04ee67-23a0-4e06-905b-5140bb228cd2",
                                          "workflowEventMapping": []
                                      },
                                      "children": []
                                  }
                              ]
                          },
                          {
                              "id": "s1672413670690",
                              "type": "autoUnderwriting",
                              "data": {
                                  "name": "Auto Underwriting",
                                  "guid": "fb5abda9-f5e7-413b-8ac1-87766636630d",
                                  "workflowEventMapping": []
                              },
                              "children": [
                                  {
                                      "id": "s1672413686580",
                                      "type": "policyIssuence",
                                      "data": {
                                          "name": "Policy Issuence",
                                          "guid": "2018e5d9-6954-4811-835a-9d25da6f6678",
                                          "workflowEventMapping": []
                                      },
                                      "children": []
                                  },
                                  {
                                      "id": "s1672413703810",
                                      "type": "policyReject",
                                      "data": {
                                          "name": "Policy Reject",
                                          "guid": "6a04ee67-23a0-4e06-905b-5140bb228cd2",
                                          "workflowEventMapping": []
                                      },
                                      "children": []
                                  }
                              ]
                          }
                      ]
                  }
              ]
          }
        }
      }
    }
  ]

  // broadcast 
  private event: Subject<Event> = new Subject<Event>();

  public broadcast(event): void {
    return this.event.next(event);
  }

  public getEvents(event): Observable<Event> {
    // DO NOT SUBSCRIBE HERE. Return the observable.
    return this.event.asObservable()

    // Only keep events matching the given `event` param
  }

  // End: Workflow Configurator essentials


  constructor(private router: Router) { }

  nullifyTransactionEmitters() {
    let nullValue = null
    let emptyObject = {}
    let emptyArray = []
    this.payeeListSubject$.next(nullValue)
    this.policyListSubject$.next(nullValue)
    this.insuredClientDOSubject$.next(nullValue)
    this.selectedPolicySubject$.next(nullValue)
    this.policyListEditModeSubject$.next(nullValue)
    this.claimIOForDocumentManagerSubject$.next(nullValue)
    this.nomineeListSubject$.next(nullValue)
    this.payeeListSubject$.next(nullValue)
    this.claimantAsNomineeFlagSubject$.next(nullValue)
    this.transactionSubject$.next(emptyObject)
    this.viewDocumentInSplitMode$.next(emptyArray);
    this.taskSubject$.next(nullValue);
    this.ocrTransactionSubject$.next(emptyObject);
    this.addClientData$.next(nullValue);
  }

  pingSubject$: Subject<string> = new Subject();
  pingChildToReact(param?) {
    this.pingSubject$.next(param);
  }

  policyListSubject$: BehaviorSubject<string> = new BehaviorSubject(null);
  sendPolicyListToInsured(policyList?) {
    this.policyListSubject$.next(policyList);
  }

  policySubject$: BehaviorSubject<string> = new BehaviorSubject(null);
  sendPolicyToPolicySummary(policy?) {
    let policies: any = [policy]
    this.policySubject$.next(policies);
  }

  insuredClientDOSubject$: BehaviorSubject<string> = new BehaviorSubject(null);
  sendSelectedInsuredClientDO(insuredClientDO?) {
    this.insuredClientDOSubject$.next(insuredClientDO);
  }

  selectedPolicySubject$: Subject<string> = new Subject();
  sendSelectedPolicyToPolicyList(policyList?) {
    this.selectedPolicySubject$.next(policyList);
  }

  policyListEditModeSubject$: BehaviorSubject<string> = new BehaviorSubject(null);
  sendPolicyListInEditMode(policyList?) {
    this.selectedPolicySubject$.next(policyList);
  }

  claimIOForDocumentManagerSubject$: BehaviorSubject<string> = new BehaviorSubject(null);
  sendClaimIOForDocumentManager(claimIO?) {
    this.claimIOForDocumentManagerSubject$.next(claimIO);
  }

  currentChecklistSubject$: BehaviorSubject<any> = new BehaviorSubject([]);
  setCurrentChecklist(checklistArray) {
    this.currentChecklistSubject$.next(checklistArray);
  }

  busineessTypeSubject$: BehaviorSubject<string> = new BehaviorSubject(null);
  setBusinessType(type?) {
    this.busineessTypeSubject$.next(type);
  }
  pingPolicyComponentToRefresh : BehaviorSubject<any> =  new BehaviorSubject(false);
  documentPanelOpenStatusSubject$: Subject<boolean> = new Subject();
  setDocumentPanelOpenStatus(status) {
    this.documentPanelOpenStatusSubject$.next(status);
  }

  transactionSubject$: BehaviorSubject<any> = new BehaviorSubject({});
  sendIOToTransaction(state, lob, product, proposalType, data?, taskId?, intimationSourceCd?, inboxType?, isNewTransaction?) {
    let output = { state: state, proposalType: proposalType || null, IO: data, taskId: taskId || null, intimationSourceCd: intimationSourceCd || null, inboxType: inboxType || null, lob: lob || null, product: product || null , isNewTransaction: isNewTransaction }
    this.transactionSubject$.next(output);
  }
  openNewTransaction(state, lob, product, proposalType?, intimationSourceCd?, inboxType?) {
    console.log("transaction state", state);
    this.sendIOToTransaction(state, lob, product, proposalType, null, null, intimationSourceCd, null, true)
    if (state == 'proposal_ManualUw' || state == 'REFERRALS') {
      this.router.navigateByUrl("/app/nbu/transaction/details");
    }
    else if (state == 'claimIntimation') {
      this.router.navigateByUrl("/app/claims/transaction/details");
    }
    else if (state == 'proposal_DataEntry') {
      this.router.navigateByUrl("/app/nbu/transaction/details");
    }
    else if (state == 'proposal_CounterOffer') {
      this.router.navigateByUrl("/app/nbu/transaction/details");
    }
    else if (state == 'policyServicingTask') {
      this.router.navigateByUrl("/app/policyServicing/transaction/details");
    }
    else if (state == 'policyServicingCustomerTask') {
      this.router.navigateByUrl("/app/policyServicing/transaction/details");
    }
  }


  //TODO send valida data
  // openNewBulkIntimation() {
  //   this.router.navigateByUrl("/app/claims/intimation/newBulk");
  // }
  bulkUploadType: String
  openNewBulkIntimation(uploadType) {
    this.bulkUploadType = uploadType;
    this.router.navigateByUrl("/app/nbu/proposal/newBulk");
  }


  addClientSubject$: Subject<any> = new Subject();
  sendClientDOtoClientList(data?) {
    this.addClientSubject$.next(data)
  }

  addClientData$: BehaviorSubject<any> =  new BehaviorSubject(null);
  sendClientDOclaimClient(data?) {
    this.addClientData$.next({...data})
  }

  updatedClientData$: BehaviorSubject<any> =  new BehaviorSubject(null);
  sendUpdatedData(role?) {
    this.updatedClientData$.next(role)
  }


  removeClientSubject$: Subject<any> = new Subject();
  removeClient(role, clientDO, index?, list?) {
    let c = { role: role, clientDO: clientDO, index: index, list: list }
    this.removeClientSubject$.next(c)
  }

  nomineeListSubject$: BehaviorSubject<string> = new BehaviorSubject(null);
  sendNomineeListToBankDetails(nomineeList?) {
    this.nomineeListSubject$.next(nomineeList);
  }

  payeeListSubject$: BehaviorSubject<string> = new BehaviorSubject(null);
  sendPayeeListToBankDetails(payeeList?) {
    this.payeeListSubject$.next(payeeList);
  }

  claimantAsNomineeFlagSubject$: BehaviorSubject<string> = new BehaviorSubject(null);
  setClaimantAsNominee(claimantAsNomineeFlag) {
    this.claimantAsNomineeFlagSubject$.next(claimantAsNomineeFlag);
  }

  transactionCloserSubject$: BehaviorSubject<any> = new BehaviorSubject(null);
  transactionCloserState(data?) {
    this.transactionCloserSubject$.next(data)
  }

  referToRoleUserType$: BehaviorSubject<any> = new BehaviorSubject(null);
  referToRoleUserType(data?) {
    this.referToRoleUserType$.next(data)
  }

  bankPingSubject$: Subject<string> = new Subject();
  pingBankChildToReact(param?) {
    this.bankPingSubject$.next(param);
  }



  bulktransactionSubject$: BehaviorSubject<any> = new BehaviorSubject({});
  sendIOToBulkTransaction(state, data?) {
    let output = { state: state, IO: data }
    this.bulktransactionSubject$.next(output);
  }

  closeModelSubject$: Subject<string> = new Subject();
  closeAllModel(param?) {
    this.closeModelSubject$.next(param);
  }


  taskSubject$: BehaviorSubject<any> = new BehaviorSubject({});
  sendTaskTOWorkBench(data?, event?) {
    let output = { data: data, event: event }
    this.taskSubject$.next(output);
  }

  fraudRulePingSubject$: Subject<string> = new Subject();
  pingFraudRuleChildToReact(param?) {
    this.fraudRulePingSubject$.next(param);
  }
  
  refreshWorkbenchSubject$: BehaviorSubject<any> = new BehaviorSubject(null);
  pingForRefreshWorkbench() {
    this.refreshWorkbenchSubject$.next(true);
  }

  refreshLookupsSubject$: Subject<any> = new Subject();
  pingForRefreshLookups(){
    this.refreshLookupsSubject$.next(true);
  }

  insuredListSubject$: BehaviorSubject<any> = new BehaviorSubject(null);
  sendInsuredList(data) {
    this.insuredListSubject$.next(data);
  }

  public latestProductDataSubject$: BehaviorSubject<any> = new BehaviorSubject(null);
  public sendLatestProductData(data?) {
    this.latestProductDataSubject$.next(data);
  }

  public baseProductDataChangeSubject$: BehaviorSubject<any> = new BehaviorSubject(null);
  public sendBaseProductChangedData(data?) {
    this.baseProductDataChangeSubject$.next(data);
  }

  tandCPolicySubject$: Subject<string> = new BehaviorSubject(null);
  setSelectdpolicy(param) {
    this.tandCPolicySubject$.next(param);
  }

  genericDataSubject$: Subject<string> = new BehaviorSubject(null);
  sendGenericData(data) {
    this.genericDataSubject$.next(data);
  }

  selectedAgentsListSubject$: Subject<any> = new Subject();
  selectedAgentsList(data?) {
    this.selectedAgentsListSubject$.next(data)
  }

  pingAgentSubject$: Subject<any> = new Subject();
  pingAgentSearch(data?) {
    this.pingAgentSubject$.next(data);
  }

  productConfigSubject$: Subject<any> = new Subject();
  sendProductConfig(data?) {
    this.productConfigSubject$.next(data)
  }

  refreshCoveragesSubject$: Subject<any> = new Subject();
  pingForRefreshCoverages() {
    this.refreshCoveragesSubject$.next(true);
  }

  refreshBasePlanSubject$: Subject<any> = new Subject();
  pingForRefreshBasePlan() {
    this.refreshBasePlanSubject$.next(true);
  }

  selectedProductSubject$: Subject<any> = new Subject();
  sendSelectedProduct(data?) {
    this.selectedProductSubject$.next(data)
  }

  refreshCoverageSubject$: Subject<any> = new Subject();
  pingForRefreshCoverage(selectedProduct) {
    this.refreshCoverageSubject$.next(selectedProduct);
  }
  
  refreshTranslateToggleSubject$: Subject<any> = new BehaviorSubject(null);
  refreshTranslateCall(langCd: string) {
    this.refreshTranslateToggleSubject$.next(langCd);
  }

  sendLongiLatiSubject$: BehaviorSubject<any> = new BehaviorSubject(null);

  viewDocumentInSplitMode$: Subject<Array<any>> = new Subject();
  viewDocumentInSplitMode(data) {
    this.viewDocumentInSplitMode$.next(data);
  }
  processBulkIntimationTransactionSubject$: BehaviorSubject<any> = new BehaviorSubject({});
  sendIOTopProcessBulkIntimationTransaction(data?) {
    let output = data
    this.processBulkIntimationTransactionSubject$.next(output);
  }
  
  sendriskSummarizationContentSubject$: Subject<Array<any>> = new Subject();
  sendriskSummarizationContent(data) {
    this.sendriskSummarizationContentSubject$.next(data);
  }

  ocrTransactionSubject$: BehaviorSubject<any> = new BehaviorSubject({});
  sendIOToOCRTransaction(state,data,inboxType){
    let output = { state : state ,IO: data, inboxType: inboxType}
    this.ocrTransactionSubject$.next(output);
  }

  uploadType: String
  openClaimViaOCR(uploadType, intimationType, redirectTo?) {
    this.uploadType = uploadType;
    this.router.navigate(["/app/claims/intimation/caseWithOCR"], { state: { redirectToURL:redirectTo, intimationType: intimationType } });
  }
  

}
